export enum CpqStatus {
  TO_BE_PUSHED = 'TO_BE_PUSHED',
  QUOTE_PUSHED = 'QUOTE_PUSHED',
  PUSHED = 'PUSHED'
}
